import { LBProgressBarChart } from '@linearb/buzz';
import useWorkingDaysUtils from 'views/root/views/home/hooks/useWorkingDaysUtils';

const DaysLeft = ({ activeIteration, selectedTeam }) => {
  const { calculateWorkingDaysDiff } = useWorkingDaysUtils({
    teamId: selectedTeam?.id
  });

  const { start_date: startDate, end_date: endDate } = activeIteration || {};
  if (!startDate || !endDate) return null;

  const { passedDays, leftDays, totalDays } = calculateWorkingDaysDiff({
    startDate,
    endDate
  });

  if (!totalDays) return null;

  return (
    <div className='flex gap-2 items-center'>
      <div className='w-[10rem]'>
        <LBProgressBarChart
          className='h-3 w-full'
          colors={['#5B66FB', '#E5E7EB']}
          data={[
            {
              passedDays,
              leftDays
            }
          ]}
          innerPadding={0}
          keys={['passedDays', 'leftDays']}
          label={null}
          tooltip={() => null}
        />
      </div>
      <div className='text-sm font-bold'>
        <span className='text-primary'>{leftDays}</span>
        <span className='text-muted-foreground'>/{totalDays}</span>
      </div>
      <div className='text-xs text-muted-foreground'>Working days left</div>
    </div>
  );
};

export default DaysLeft;
